export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [6,[2]],
		"/about/community": [8,[2]],
		"/about/[page]": [7,[2]],
		"/compress": [9],
		"/convert": [10],
		"/donate": [11],
		"/remux": [12],
		"/settings": [13,[3]],
		"/settings/accessibility": [14,[3]],
		"/settings/advanced": [15,[3]],
		"/settings/appearance": [16,[3]],
		"/settings/audio": [17,[3]],
		"/settings/debug": [18,[3]],
		"/settings/instances": [19,[3]],
		"/settings/local": [20,[3]],
		"/settings/metadata": [21,[3]],
		"/settings/privacy": [22,[3]],
		"/settings/video": [23,[3]],
		"/updates": [24],
		"/[...prefill]": [5]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';